// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__pUTUf","description":"MealItem_description__I57kh","price":"MealItem_price__vqWJy"};